/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * ----
 * ROOT
 * ****
 *
 * Root is het hoogste niveau van een navigatie structuur. In tegenstelling tot een standaard APP wordt dit item niet weergegeven in het App Menu (Hamburger)
 * Dit geeft de mogelijkheid om elders dit menu aan te spreken. Bv: een tandwiel voor systeem instellingen.
 *
 * Dit item kan en/of een pagina bevatten en/of een submenu activeren.
 *             
 * ---
 * APP
 * ***
 *             
 * App is het hoogste niveau van een standaard menu. Dit dient om de "app" in het App-menu (hamburger) weer te geven.
 * Een app kan bevat standaard submenu's, maar kan ook een eigen home pagina hebben.
 *             
 * ----
 * Menu
 * ****
 *             
 * Menu is een item in het sub-menu dat altijd wordt weergegeven, en GEEN pagina opent.
 * Dit niveau dient enkel om binnen een applicatie een menustructuur op te bouwen.
 *
 * ------
 * Pagina
 * ******
 *             
 * Een pagina is de link naar een effectief component in code.
 * De naam van de pagina is de naam dat wordt weergegeven in het menu.
 *             
 * Een pagina opent ALTIJD een component, maar kan optioneel ook een nieuw sub-menu laden.
 *             
 * --------------
 * DoorklikPagina
 * **************
 *             
 * Doorklik pagina's zijn pagina's die niet via het menu benaderd kunnen worden.
 * Deze pagina's kunnen enkel benaderd worden door een andere "parent" page.
 *             
 * De behoefte aan een "doorklik pagina" wordt aangegeven in de config-file van de parent page.
 *             
 * Deze pagina's moeten aangemaakt worden als NavigationItem omdat we hierdoor verschillende rechten kunnen toekennen aan dit element,
 * per link met een user groep, zonder rekening te houden met de parent page.
 *
 * 0 = Unknown
 * 1 = Root
 * 2 = App
 * 3 = Group
 * 4 = Page
 * 5 = DoorklikPagina
 */
export enum PlatformNavigationItemType {
  Unknown = 0,
  Root = 1,
  App = 2,
  Group = 3,
  Page = 4,
  DoorklikPagina = 5
}
